const googleBusinessApi = ({ apiClient }) => ({
  connect() {
    return apiClient.get('/reviews/google-business/connect')
  },

  status() {
    return apiClient.get('/reviews/google-business/status')
  },

  sync() {
    return apiClient.post('/reviews/google-business/sync')
  },

  disconnect() {
    return apiClient.delete('/reviews/google-business/disconnect')
  },

  locations() {
    return apiClient.get('/reviews/google-business/locations')
  },

  updateLocationLabel(locationId, label) {
    return apiClient.patch(`/reviews/google-business/locations/${locationId}/label`, { label })
  },

  reviews() {
    return apiClient.get('/reviews/google-business/reviews')
  },

  toggleFeatured(reviewId) {
    return apiClient.patch(`/reviews/google-business/reviews/${reviewId}/featured`)
  },
})

export default googleBusinessApi
